(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'DateUtils', 'PublicCurves'];

    function HomeController ($scope, Principal, LoginService, $state, DateUtils, PublicCurves) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.hasAnyAuthority = null;
        vm.login = LoginService.open;
        vm.register = register;
        // the public IRS and cross-currency curves (as on #/curves), loaded for anonymous visitors only; a failure shows
        // a notice and never holds up the sign-in box
        vm.curves = null;
        vm.curvesLoaded = false;
        vm.date = new Date();
        vm.conventionsUrl = 'content/pdf/EBRD curves conventions.pdf';
        var curvesRequested = false;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.hasAnyAuthority = Principal.hasAnyAuthority;
                if (vm.isAuthenticated()) {
                    $state.go('main');
                } else {
                    loadCurves();
                }
            });
        }

        function loadCurves() {
            if (curvesRequested) {
                return;
            }
            curvesRequested = true;
            PublicCurves.get().$promise.then(function (curves) {
                vm.curves = curves;
                // the date comes from the server (Prague), as on the public curves page
                if (curves && curves.date) {
                    vm.date = DateUtils.convertLocalDateFromServer(curves.date);
                }
            }).catch(function () {
                vm.curves = null;
            }).finally(function () {
                vm.curvesLoaded = true;
            });
        }


        function register () {
            $state.go('register');
        }

    }
})();
